var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeatSwatch = function SvgHeatSwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heat-swatch_svg__a)",
    filter: "url(#heat-swatch_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.66,
    r: 10,
    fill: "url(#heat-swatch_svg__c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "heat-swatch_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 9.99998 -10 0 12 12.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#B40F1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#EB884A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#F7F2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF7AE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "heat-swatch_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .66h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "heat-swatch_svg__b",
    width: 26,
    height: 26,
    x: -1,
    y: -0.34,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_25331_85419",
    stdDeviation: 1.5
  })))));
};
export default SvgHeatSwatch;